<div class="position-relative">
  <header [ngClass]="{ hidden: isHeaderHidden }" class="top-0 position-sticky primary-bg z-index-9">
    <div class="container d-flex justify-content-between align-items-center">
      <div class="logo-box">
        <img class="logo-box__img" alt="JECRM Logo" [src]="'/assets/svgs/logos/Logo_JE_128x420_p2.svg'" />
      </div>
      <div>
        <button class="px-4 py-2 primary-btn" (click)="goToLogin()">
          {{ 'login' | translate }}
        </button>
      </div>
    </div>
  </header>
  <div class="primary-bg">
    <div class="container">
      <div class="demo-block gap-4 d-flex py-5 align-items-center">
        <div class="text-center d-flex align-self-center flex-column">
          <div class="d-flex flex-column align-items-center">
            <h2 class="text-white">Розкрийте потенціал OLX з {{ NAME_PROJECT }}</h2>
            <p>Почніть заробляти власні кошти там, де раніше витрачали.</p>
          </div>
          <div class="gap-4 d-flex flex-wrap justify-content-center">
            <button class="primary-btn px-3 py-1 rounded-5" (click)="goToRegister()">Спробувати безкоштовно</button>
            <button class="text-decoration-none secondary-btn px-3 py-1 rounded-5" (click)="scrollTo('functional')">
              Дізнатися про PowerOLX
            </button>
          </div>
        </div>
        <div>
          <iframe
            class="rounded-4 frame-video frame-video__light img-fluid"
            width="640px"
            height="360px"
            src="https://www.youtube.com/embed/az6cTD2Cus0"
            allowfullscreen
            title="Короткий огляд JECRM - crm для OLX"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
  <div class="container d-flex flex-row justify-content-center align-items-center py-5 gap-5 flex-wrap-reverse">
    <div class="text-dark text-center px-4 max-w-500">
      <h1 class="mb-4">Оптимізуйте спілкування через всі OLX акаунти</h1>
      <p>
        Наш зручний інтерфейс дозволяє вам однаково легко керувати і взаємодіяти з усіма вашими підключеними акаунтами,
        надаючи вам центральний доступ до всіх ваших комунікаційних потоків і інших ресурсів.
      </p>
      <p>
        Це зробить вашу роботу більш ефективною та продуктивною, освіжить вашу комунікацію та відкриє нові можливості
        для співпраці та зв'язку з вашими обліковими записами.
      </p>
    </div>
    <div class="d-flex">
      <img class="img-fluid" alt="Channels Demo" src="/assets/svgs/special/channels.svg" />
    </div>
  </div>

  <div class="container d-flex flex-row justify-content-center align-items-center py-5 gap-5 flex-wrap">
    <div class="d-flex">
      <img class="img-fluid" alt="Chats Demo" src="/assets/images/special/chats.png" />
    </div>
    <div class="text-dark text-center px-4 max-w-500">
      <h1 class="mb-4">{{ 'messages_from_all_accounts_in_a_convenient_interface' | translate }}</h1>
      <p>
        {{
          'communicate_with_your_customers_easily_and_efficiently._Our_service_combines_all_your_OLX_accounts_in_one_convenient_interface'
            | translate
        }}
      </p>
      <p>{{ 'now_you_can' | translate }}.</p>
    </div>
  </div>

  <div id="functional">
    <div class="container d-flex py-5 flex-wrap justify-content-center">
      <div class="p-4 text-center d-flex align-self-center flex-column text-dark max-w-500">
        <h2 class="mb-4">
          {{ 'introducing_the_PowerOLX_app' | translate }}
        </h2>
        <p>
          {{
            'powerOLX_is_a_JECRM_tool_that_allows_you_to_automate_the_work_with_ads_on_OLX,_activate_your_ads_instantly_or_on_a_schedule._This_allows_you_to_reach_a_larger_audience_and_get_more_sales'
              | translate
          }}.
        </p>
        <span class="fw-bold">
          {{ 'we_invite_you_to_test_PowerOLX_in_the_Applications_section_JECRM_System_Store' | translate }}.
        </span>
      </div>
      <div class="d-flex justify-content-center flex-wrap gap-4">
        <img class="w-75" src="/assets/images/home/powerOLX.jpg" alt="PowerOLX" />
      </div>
    </div>
  </div>

  @if (false) {
    <div id="functional-old">
      <div class="container d-flex py-5 flex-wrap justify-content-center">
        <div class="p-4 text-center d-flex align-self-center flex-column text-dark max-w-500">
          <h2 class="mb-4">
            {{ 'more_about_the_functionality' | translate }}
          </h2>
          <p>
            {{ 'learn_more_about_our_products_and_how_they_work_in_our_short_video' | translate }}.
            {{ 'see_how_our_solutions_can_make_your_life_and_business_easier' | translate }}.
          </p>
          <span class="fw-bold"> {{ 'enjoy_the_video' | translate }}! </span>
        </div>
        <div class="d-flex justify-content-center flex-wrap gap-4">
          <iframe
            class="rounded-4 frame-video frame-video__dark img-fluid"
            width="620px"
            height="330px"
            src="https://www.youtube.com/embed/yoItYPLsW5k"
            allowfullscreen
            title="JECRM - розкрийте потенціал OLX. Частина 1. Презентація"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
          <iframe
            class="rounded-4 frame-video frame-video__dark img-fluid"
            width="620px"
            height="330px"
            src="https://www.youtube.com/embed/eJBZVdY9Bw0"
            allowfullscreen
            title="JECRM - розкрийте потенціал OLX. Частина 2. Функціонал"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </div>
    </div>
  }
  <div class="container d-flex justify-content-center align-items-center flex-column mb-5">
    <h1 class="text-dark text-center mb-5">{{ 'we_offer_you_the_following_pricing_plans' | translate }}:</h1>
    <div class="d-flex flex-wrap justify-content-center gap-4 text-center">
      @for (tariff of tariffPackages; track tariff) {
        <div class="shadow rounded-3 overflow-hidden">
          <div
            [ngStyle]="{ background: tariff.color ? tariff.color : '#483CE4' }"
            class="d-flex justify-content-between w-100 p-3"
          >
            <h3>{{ tariff.title }}</h3>
            <h3>
              <span>
                {{ parseCurrency(tariff.price, 'USD') }}
              </span>
            </h3>
          </div>
          <div class="text-dark p-3">
            @for (additional of tariff.additional; track additional) {
              <p class="d-flex gap-2 text-secondary text-start">
                @if (additional?.additionally) {
                  <ng-container class="px-2">
                    <app-icon> add </app-icon>
                  </ng-container>
                } @else {
                  @if (additional?.included) {
                    <ng-container class="px-2">
                      <app-icon> check </app-icon>
                    </ng-container>
                  } @else {
                    <app-icon> close </app-icon>
                  }
                }
                {{ parseName(additional.name, tariff.keys) }}
              </p>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="container d-flex justify-content-center align-items-center flex-column">
    <h1 class="text-dark text-center mb-5">{{ 'by_choosing_us_you_get' | translate }}:</h1>
    <div class="d-grid responsive-grid-block">
      @for (advantage of arrAdvantages; track advantage) {
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img class="mb-3" [src]="advantage.img" alt="Advantage" />
          <p class="text-dark text-center">{{ advantage.description }}</p>
        </div>
      }
    </div>
  </div>
  <footer class="footer d-flex flex-column">
    <div class="container d-flex flex-column align-items-center gap-4">
      <div class="align-self-start">
        <img class="users-icon" src="/assets/svgs/home/users.svg" alt="Users Icon" />
      </div>
      <div>
        <p>❤️ Just your Electronic system Customer Relations Management ❤️</p>
        <h2>{{ 'we_care_about_our_customers' | translate }}</h2>
        <p>
          {{
            'our_primary_goal_is_your_complete_satisfaction._We_dedicate_many_hours_and_effort_to_provide_you_with_the_best_service_and_provide_you_with_solutions_that_truly_meet_your_needs'
              | translate
          }}.
        </p>
        <p>{{ 'you_are_our_main_goal_and_we_are_proud_of_our_ability_to_make_your_life_better' | translate }}.</p>
      </div>
      <mat-divider class="bg-white w-100 mt-4 mb-2"></mat-divider>
      <div class="d-flex flex-wrap justify-content-center gap-4 text-center">
        @for (stat of arrStatistics; track stat) {
          <div>
            <h3>{{ stat.count }}</h3>
            <p class="text-nowrap">{{ stat.name }}</p>
          </div>
        }
      </div>
      <mat-divider class="bg-white w-100 mt-4 mb-2"></mat-divider>
    </div>
    <div class="info-box py-2 container d-flex justify-content-between gap-2">
      <div class="d-flex" style="width: 200px">
        <img class="w-100" alt="JECRM Logo" src="/assets/svgs/logos/Logo_JE_128x420_p2.svg" />
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <img class="me-2" width="24" src="/assets/svgs/home/telegram.svg" />
        <!--        <app-icon class="me-2">data</app-icon>-->
        <a class="text-white" target="_blank" href="https://t.me/+yj4HkBvmAnUxMGRi">Приєднуйтеся до спільноти!</a>
      </div>
      <div>
        @for (contact of arrUsContacts; track contact) {
          <div class="d-flex align-items-center">
            <app-icon class="me-2">{{ contact.icon }}</app-icon>
            @if (contact.copyData) {
              <a class="text-white" [href]="contact.copyData">{{ contact.text }}</a>
            }
            @if (!contact.copyData) {
              <span>{{ contact.text }}</span>
            }
          </div>
        }
      </div>
    </div>
    <div class="d-flex justify-content-center text-center text-dark bg-white footer-spacing">
      <p class="my-0 px-2">
        Copyright© {{ currentYear }} {{ NAME_PROJECT }}. Created by
        <a target="_blank" [href]="'https://jestos.org/'">Jestos</a>
      </p>
    </div>
  </footer>
</div>
